"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const __1 = require("../../");
const normal_attack_1 = tslib_1.__importDefault(require("../common/normal-attack"));
const skill_1 = require("../../skill");
exports.nurikabes_skill1 = new normal_attack_1.default('地震');
exports.nurikabes_skill2 = {
    no: 2,
    name: '坚壁',
    cost: 2,
    target: skill_1.SkillTarget.TEAM,
    use(battle, sourceId, _) {
        const source = battle.getEntity(sourceId);
        const entities = battle.getTeamEntities(source.teamId); // 所有队友
        entities.forEach(e => {
            const buff = __1.Buff.build(sourceId, e.entityId)
                .name('坚壁', 1)
                .countDown(2)
                .buffAP(__1.BattleProperties.DEF, __1.EffectTypes.FIXED, 0.2 * source.getProperty(__1.BattleProperties.DEF) + 0.4 * e.getProperty(__1.BattleProperties.DEF))
                .end();
            battle.actionAddBuff(buff, __1.Reasons.SKILL);
        });
    },
};
